import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ── PWA Service Worker Registration ─────────────────────────────────────
// Only register in production — in development the SW causes infinite reload loops
// because the dev server's hot-reload and SW caching conflict with each other
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' })
      .then(registration => {
        console.log('[PWA] Service Worker registered:', registration.scope);
        navigator.serviceWorker.addEventListener('message', (event) => {
          if (event.data?.type === 'PROCESS_OFFLINE_QUEUE') {
            processOfflineQueue();
          }
        });
      })
      .catch(err => console.warn('[PWA] SW registration failed:', err));
  });
} else if ('serviceWorker' in navigator && process.env.NODE_ENV !== 'production') {
  // In development: unregister any existing SW to prevent stale cache loops
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(r => r.unregister());
  });
}

// ── Offline Queue Processor ───────────────────────────────────────────────
async function processOfflineQueue() {
  const queue = JSON.parse(localStorage.getItem('faristaa_offline_queue') || '[]');
  if (!queue.length || !navigator.onLine) return;

  const remaining = [];
  for (const item of queue) {
    try {
      const res = await fetch(item.url, {
        method:  item.method || 'POST',
        headers: { 'Content-Type': 'application/json', ...item.headers },
        body:    JSON.stringify(item.body),
      });
      if (!res.ok) remaining.push(item);
      else console.log('[Offline Queue] Synced:', item.url);
    } catch {
      remaining.push(item); // still offline
    }
  }
  localStorage.setItem('faristaa_offline_queue', JSON.stringify(remaining));
  if (remaining.length < queue.length) {
    window.dispatchEvent(new CustomEvent('faristaa:queue-synced', { detail: { synced: queue.length - remaining.length } }));
  }
}

// Run queue on app load if online
window.addEventListener('online', processOfflineQueue);
if (navigator.onLine) setTimeout(processOfflineQueue, 3000);

// ── PWA Install Prompt ───────────────────────────────────────────────────
let deferredInstallPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredInstallPrompt = e;
  window.dispatchEvent(new CustomEvent('faristaa:install-ready'));
});

window.showPWAInstallPrompt = () => {
  if (deferredInstallPrompt) {
    deferredInstallPrompt.prompt();
    deferredInstallPrompt.userChoice.then(result => {
      if (result.outcome === 'accepted') {
        window.dispatchEvent(new CustomEvent('faristaa:install-accepted'));
      }
      deferredInstallPrompt = null;
    });
  }
};
